'use client'

import { MouseEvent, useState } from 'react'
import { GenericLink } from '../GenericLink'
import { useRouter } from 'next/navigation'

type Props = {
  initialCount?: number | null
  initialActive?: boolean
  onClick?: () => Promise<boolean> | boolean
  className?: string
  children: (val: number, active: boolean) => React.ReactNode
}

export const IncrementalButton = ({
  initialCount,
  initialActive,
  className,
  children,
  onClick,
}: Props) => {
  const router = useRouter()
  const [internalActive, toggle] = useState(initialActive || false)

  const internalOnClick = async (e: MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    const res = (await onClick?.()) || false
    toggle(res)
  }

  const value = initialCount || 0
  const incValue =
    !initialActive && internalActive
      ? 1
      : initialActive && !internalActive
      ? -1
      : 0
  const computedValue = value + incValue

  return (
    <GenericLink onClick={internalOnClick} privilege className={className}>
      {children(computedValue, internalActive)}
    </GenericLink>
  )
}
